import React from 'react';
import { Hero } from './components/Hero';
import { HeroTestimonials } from './components/HeroTestimonials';
import { ProblemSection } from './components/ProblemSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { UpsellTable } from './components/UpsellTable';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostSection } from './components/CostSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { LiveToast } from './components/LiveToast';
export function App() {
  return <div className="w-full overflow-x-hidden bg-ink-900 font-sans text-white" data-id="element-0" data-mp="28suumo7jhzm9">
      <Hero data-id="element-1" data-mp="23u9tmmkgrbwr" />
      <main data-id="element-2" data-mp="23ujlkfp2jt53">
        <HeroTestimonials data-id="element-3" data-mp="23v2r0wxj8p28" />
        <ProblemSection data-id="element-4" data-mp="3ijxpcqos80jw" />
        <VolumesSection data-id="element-5" data-mp="3ikh9me1wn113" />
        <BonusesSection data-id="element-6" data-mp="3ij66mgga9xb1" />
        <PricingSection id="ofertas" data-id="element-7" data-mp="3ihv22ef0kliv" />
        <UpsellTable data-id="element-8" data-mp="3ml14faz09sk2" />
        <TestimonialsSection data-id="element-9" data-mp="3mkhmvvd9p66k" />
        <GuaranteeSection data-id="element-10" data-mp="3mjq45l4rr2xp" />
        <FaqSection data-id="element-11" data-mp="3rc9ca2kot5v4" />
        <CostSection data-id="element-12" data-mp="3rbrcwx2qabiz" />
        <FinalCta data-id="element-13" data-mp="3rdkie91luppe" />
      </main>
      <Footer data-id="element-14" data-mp="3reccfffk0fdk" />
      <LiveToast data-id="element-15" data-mp="5yj0slx59ec" />
    </div>;
}